<template>
  <div class="wrap">

    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">
      <div class="form-title-wrap">
        <form-title :tip="tip" :flag="flag" :tip3="tip3"></form-title>
      </div>
      <div class="edit-form">

        <div class="edit-form-wrap" >

            <el-form
            :model="editForm"
            :rules="rules"
            ref="editForm"
            label-width="100px"
            class="form" >

            <el-form-item label="用户名" prop="username" >
              <el-input
                v-model="editForm.username"
                placeholder="请填写您的用户名"
                clearable
                disabled
              />
            </el-form-item>

            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请填写您的真实有效姓名"
                clearable
              />
            </el-form-item>


            <el-form-item label="身份证" prop="id" >
              <el-input
                v-model="editForm.id"
                placeholder="请填写您的真实身份证"
                clearable
                :disabled="true"
              />
            </el-form-item>



            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="editForm.sex">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="editForm.email"
                placeholder="请输入您的电子邮箱地址接收信息"
                clearable
              />
            </el-form-item>

            <el-form-item label="手机号" prop="telphone">
              <el-input
                v-model="editForm.telphone"
                placeholder="请输入手机号"
                clearable
                autoComplete="off"
              />
            </el-form-item>


            <div class="form-opts" >
              <el-button type="primary" @click="submit('editForm')">
                保存
              </el-button>
              <el-button type="info" @click="setDefaultUserInfo()" >
                重置
              </el-button>
            </div>


          </el-form>

        </div>

      </div>
    </div>
  </div>
</template>

<script>

import formTitle from '../common/formTitle';
// import { sendValidCode, newPwd } from '../request/regAndEdit';
import { Message } from 'element-ui';
import { queryUser, modifyUser } from '../request/regAndEdit';
import { getLoginUser } from '../../utils/auth';
import BrowserSuggestion from '../common/BrowserSuggestion';

import { ValidateFormIdNum, ValidateFormPhone, ValidateFormEmail } from '../../utils/tools';



export default {
  name: 'person-center',
  components: {
    formTitle,
    BrowserSuggestion
  },
  data() {

    return {
      editForm: {
        username: '',
        name: '',
        id: '',
        sex: '',
        email: '',
        telphone: ''
      },
      show: true,
      disabledCodeBtn: true,
      count: '',
      timer: null,
      serverCode: '',

      tip: '修改注册信息',
      tip3: '温馨提示：姓名将用于简历投递，新增简历时生效，历史简历可在简历中修改。 ',
      flag: true,
      rules: {
        username: [
          { required: true, message: '请输入字母或数字', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入中文或字母', trigger: 'blur' }
        ],
        id: [{ required: true, validator: ValidateFormIdNum, trigger: 'blur' }],
        sex: [
          { required: true, message: '请选择您的性别', trigger: 'blur' }
        ],
        email: [{ required: true, validator: ValidateFormEmail, trigger: 'blur' }],
        telphone: [{ required: true, validator: ValidateFormPhone, trigger: 'blur' }],
      }

    }
  },
  methods: {

    //修改完成提交
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 验证码
          this.sendDataToServer();
        } else {
          return false
        }
      })
    },
    setDefaultUserInfo() {
        let user = getLoginUser();
        if(user) {
          var params = {
            "username": user['userName']
          }
          queryUser(params).then(res => {
            if(res.success) {

              // res.data
              this.editForm.username = res.data.username;
              this.editForm.name = res.data.name;
              this.editForm.id = res.data.id;
              this.editForm.sex = res.data.sex;
              this.editForm.email = res.data.email;

              // 设置手机号
              this.editForm.telphone = res.data.telphone;

            }

          });
          
        }
    },
    sendDataToServer() {
      let params = {
        "name": this.editForm.name,
        "username": this.editForm.username,
        "id": this.editForm.id,
        "sex": this.editForm.sex,
        "email": this.editForm.email,
        "telphone": this.editForm.telphone
      }
      modifyUser(params).then(res => {

        if(res.success) {
          Message({
                message: res.message,
                type: 'success',
                duration: 5 * 1000
          });
        } else {
          Message({
                message: res.message,
                type: 'error',
                duration: 5 * 1000
          });
        }

      });

    }

  },
  mounted() {

    // 设置用户信息
    this.setDefaultUserInfo();

  }
}
</script>

<style lang="scss" scoped>



.wrap {

  .wrapper {
    width: auto;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    padding-bottom: 40px;
  }

  .form-title-wrap {
    line-height: 40px;
    margin-bottom: 12px;
  }

  .edit-form {
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
    padding: 12px;
  }

  .edit-form-wrap {
      margin: 0 auto;
  }

  .form-opts {
    text-align: center;
  }


}



@media screen and (min-width: 320px) { 

}

@media screen and (min-width: 480px) { 
    
}
/* 移动 */
@media screen and (min-width: 576px) { 
    
}
/* 平板 */
@media screen and (min-width: 768px) { 

}

/* PC */
@media screen and (min-width: 992px) {

}
@media screen and (min-width: 1200px) {

  .wrap {

    .wrapper {
      width: 1200px;
      padding-left: 0;
      padding-right: 0;
    }


  }

}





</style>
